import { render, staticRenderFns } from "./addBlist.vue?vue&type=template&id=2829b46a&scoped=true&"
import script from "./addBlist.vue?vue&type=script&lang=js&"
export * from "./addBlist.vue?vue&type=script&lang=js&"
import style0 from "./addBlist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addBlist.vue?vue&type=style&index=1&id=2829b46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2829b46a",
  null
  
)

export default component.exports